import { createAri, type Ari } from '@atlassian/jira-platform-ari';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { useProjectId } from '../get-project';

export const useProjectAri = (): Ari | null => {
	const cloudId = useCloudId();
	const projectId = useProjectId();

	if (projectId === null) {
		return null;
	}

	return createAri({
		resourceOwner: 'jira',
		cloudId,
		resourceType: 'project',
		resourceId: projectId,
	});
};
